import { render, staticRenderFns } from "./createQuestionnaire.vue?vue&type=template&id=254f7f75&"
import script from "./createQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./createQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports